module.exports = __webpack_public_path__ + "img/hadoop.5c5d43fc.png";